function getByPath(obj, path) {
  if (obj == null) return undefined;
  return path.split(".").reduce((acc, key) => (acc == null ? undefined : acc[key]), obj);
}

function reactNodeToText(node) {
  if (node === null || node === undefined || typeof node === "boolean") return "";
  if (typeof node === "string" || typeof node === "number") return String(node);
  if (Array.isArray(node)) return node.map(reactNodeToText).join("");
  if (node.props && node.props.children !== undefined) return reactNodeToText(node.props.children);
  return "";
}

function columnLabel(columnDef) {
  if (typeof columnDef.header === "string") return columnDef.header;
  if (typeof columnDef.header === "function") {
    try {
      const text = reactNodeToText(columnDef.header({}));
      if (text) return text;
    } catch {
      // fall through to id/accessorKey below
    }
  }
  return columnDef.id || columnDef.accessorKey || "";
}

function toCsvValue(value) {
  if (value === null || value === undefined) return "";
  const str = typeof value === "object" ? JSON.stringify(value) : String(value);
  if (/[",\n]/.test(str)) return `"${str.replace(/"/g, '""')}"`;
  return str;
}

function exportableColumns(columns) {
  return columns.filter((c) => c.accessorKey || typeof c.accessorFn === "function");
}

export function rowsToCsv(columns, rows) {
  const exportCols = exportableColumns(columns);
  const header = exportCols.map((c) => toCsvValue(columnLabel(c))).join(",");
  const lines = (rows || []).map((row) =>
    exportCols
      .map((c) => {
        const value = typeof c.accessorFn === "function" ? c.accessorFn(row, 0) : getByPath(row, c.accessorKey);
        return toCsvValue(value);
      })
      .join(","),
  );
  return [header, ...lines].join("\r\n");
}

export function downloadCsv(filename, csv) {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
